import React from 'react';
import { StatisticsRouter } from './router';

const StatisticsModule = () => {
  return <StatisticsRouter />;
};

export default StatisticsModule;
